import React from "react";
import { BiLogoFacebook, BiLogoLinkedin, BiLogoTiktok } from "react-icons/bi";
import logo from "../../assets/Group 627737.svg";
import { FaInstagram } from "react-icons/fa6";

const Footer = () => {
  return (
    <div>
      <section className="footer bg-gradient-to-r from-black/80 via-black/60 to-black/80 backdrop-blur-xl border-t border-white/20">
        <div className="flex flex-col justify-center items-center">
          <div className="w-full px-4 sm:px-8 md:px-12 lg:px-16 xl:px-0 xl:w-2xl">
            <div className="flex flex-col lg:flex-row justify-between items-center py-12">
              <div className="flex flex-col lg:flex-row items-center">
                {" "}
                <div className="mb-4 lg:mb-0 lg:mr-8">
                  <img src={logo} alt="Logo" className="w-24 h-auto" />
                </div>
                <div className="font-normal text-lg text-white/90 w-full xl:w-2/5 mb-6 lg:mb-0">
                  KAHA is a location tracking app for your business and personal
                  use.
                </div>
              </div>
              <div className="flex gap-3 mt-4 text-white/90">
                <a
                  className="rounded-full border-[1px] border-white/30 hover:border-green-400 hover:text-green-400 cursor-pointer p-[6px] transition-all duration-300"
                  href="https://www.facebook.com/KAHAINC"
                  target="_blank"
                >
                  <BiLogoFacebook size={24} />
                </a>
                <a
                  className="rounded-full border-[1px] border-white/30 hover:border-green-400 hover:text-green-400 cursor-pointer p-[6px] transition-all duration-300"
                  href="https://www.instagram.com/kahaapp/"
                  target="_blank"
                >
                  <FaInstagram size={24} />
                </a>
                {/* <div className="rounded-full border-[1px] hover:bg-blue-400 cursor-pointer border-white p-1">
                  <BiLogoTiktok size={30} />
                </div> */}
                <a
                  className="rounded-full border-[1px] border-white/30 hover:border-green-400 hover:text-green-400 cursor-pointer p-[6px] transition-all duration-300"
                  href="https://www.linkedin.com/company/kahaapp/"
                  target="_blank"
                >
                  <BiLogoLinkedin size={24} />
                </a>
              </div>
            </div>
            <section className="lg:pr-0">
              <hr className="border-white/20" />
              <div className="flex flex-col gap-3 lg:gap-0 text-white/70 lg:flex-row lg:justify-between py-4">
                <p>© 2025 Kaha Inc. All rights reserved.</p>
                {/* <div className="flex flex-col lg:flex-row gap-3 pr-3">
                  <p className="text-base font-normal">Documentation</p>
                  <p className="text-base font-normal">Tutorials & Guides</p>
                  <p className="text-base font-normal">Blog</p>
                  <p className="text-base font-normal">Partners</p>
                  <p className="text-base font-normal">Webinars</p>
                </div> */}
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
